import { IError } from "../types/errors";
import { ActionType } from "../types/store-types";

/* - State - */
interface IChatMessage {
    id: string;
    role: "user" | "OpenAi";
    content: string;
    timestamp: number;
}
export interface IChatState {
    messages: IChatMessage[];
    isOpen: boolean;
    loading: boolean;
    error: string | null;
}

/* Chat related interfaces  */

interface IToggleChat {
    isOpen: boolean;
}

interface ISendMessageRequest {
    message: string;
}

interface ISendMessageSuccess {
    answer: string;
}

interface ISendMessageFailure extends IError {}

interface IAddMessage {
    message: string;
}

/* - Action Types - */

export enum ChatActionTypes {
    TOGGLE_CHAT = "CHAT.TOGGLE_CHAT",

    SEND_MESSAGE_REQUEST = "CHAT.SEND_MESSAGE_REQUEST",
    SEND_MESSAGE_SUCCESS = "CHAT.SEND_MESSAGE_SUCCESS",
    SEND_MESSAGE_FAILURE = "CHAT.SEND_MESSAGE_FAILURE",

    ADD_MESSAGE = "CHAT.ADD_USER_MESSAGE",
}

/* - Action Interfaces  - */

export type ToggleChatBotActionType = ActionType<ChatActionTypes.TOGGLE_CHAT, IToggleChat>;
export type SendMessageRequestActionType = ActionType<ChatActionTypes.SEND_MESSAGE_REQUEST, ISendMessageRequest>;
export type SendMessageSuccessActionType = ActionType<ChatActionTypes.SEND_MESSAGE_SUCCESS, ISendMessageSuccess>;
export type SendMessageFailureActionType = ActionType<ChatActionTypes.SEND_MESSAGE_FAILURE, ISendMessageFailure>;
export type AddMessageActionType = ActionType<ChatActionTypes.ADD_MESSAGE, IAddMessage>;
